<div class="hero-image">
  <h1 class="hero-title">Support</h1>
</div>
<div class="col-lg-8 offset-lg-2 pb-5">
  <h1 class="my-4">Website Support</h1>

  <p><b>Getting Help</b></p>
  <p>
    If you are having problems accessing or using the website, you can contact our web support team by e-mail at <a href="mailto:clientservices@nicolawealth.com">clientservices&#64;nicolawealth.com</a>.
    Support personnel are generally only available to respond to problems during normal business hours, so please allow for a few business days for us to respond to most requests.
    @if (user?.isClient) {
      <span>If you have questions about the portal’s features, please visit our
        @if (!reRg!.IsPershing) {
          <a href="/assets/2022-10 - Nicola Wealth Client Website User Guide.pdf" target="_blank">User Guide</a>
        }
        @if (reRg!.IsPershing) {
          <a href="/assets/2022-10 - Nicola Wealth Client Website User Guide - PERSHING.pdf" target="_blank">User Guide</a>
        }
      </span>
    }
  </p>
  <p>If the matter is of an urgent nature, please contact your advisor directly.</p>
  <p><b>Supported Browsers</b></p>
  <p>Nicola Wealth's website is best viewed with the most recent versions of popular browsers such as Firefox, Google Chrome or Safari. Older browsers no longer receive security updates and may not be compatible with the latest web standards. In keeping with those standards, we update our software to keep pace and do not support older, outdated versions. Please use a recommended, up-to-date browser to ensure the fastest and most secure experience online as well as within our application. In most browsers you can check what version you have by selecting <b>Help > About</b> from the menu bar of your browser.</p>
  <p><b>Recommended Browsers</b></p>
  <p>Latest version of one of the following browsers:</p>
  <ul>
    <li>Microsoft Edge</li>
    <li>Chrome (available from: <a href="http://www.google.com/chrome">www.google.com/chrome</a>)</li>
    <li>Firefox (available from: <a href="http://www.getfirefox.com">www.getfirefox.com</a>)</li>
    <li>Safari (available from: <a href="http://www.apple.com/safari">www.apple.com/safari</a>)</li>
  </ul>
  <p><b>Clearing the Browser Cache</b></p>
  <p>For security reasons we suggest you clear the browser cache every time you log out.</p>
  <p><b>Session Timeout</b></p>
  <p>For your security the  website will automatically log you out after 20 minutes of inactivity.  When this happen you will be required to log back in again to access the site.  It is recommended practice to always logout as soon as you are finished using the website.</p>

  <div class="h4-text py-3">Security Tips</div>
  <p><b>Protecting your login information</b></p>
  <ul>
    <li>Choose a password that is at least twelve characters in length</li>
    <li>Use at least one of each of the following: upper-case letters, lower-case letters, numbers and special characters (e.g.: !, &#64;, #, $, %, ^, &, *)</li>
    <li>Avoid using words or common names in your password</li>
    <li>Never share your login information or password by phone or e-mail with anyone, even if it is someone you trust</li>
    <li>Be wary of phishing scams in the form of e-mails appearing to be from legitimate organizations asking for personal information and login information</li>
  </ul>
  <p>Remember, Nicola Wealth employees will never ask you for your password.<br/>If you suspect your password may have been obtained by a third party please contact Nicola Wealth at 604-739-6450 immediately and if possible change your password through our website.</p>

  <p><b>Protecting your computer</b></p>
  <ul>
    <li>We recommend installing Antivirus software to protect your machine</li>
    <li>We recommend enabling your operating system's firewall </li>
    <li>Use a password on your computer's operating system which is different from your Nicola Wealth password</li>
    <li>Ensure you are installing software only from trusted sources</li>
    <li>Ensure your computer is up-to-date with the latest patches and security releases</li>
  </ul>
  <p>&#8224;None of the software programs suggested here are owned, sponsored or supported by Nicola Wealth Management Ltd. and are provided here for information purposes only. Nicola Wealth Management Ltd. provides no warranties expressed or implied as to the performance, security or stability of any of the software listed above.</p>
</div>
